import { defineMessages } from 'react-intl';

export default defineMessages({
  whatExpensesAreYouClaimingFor: {
    id: 'fastCover.adAndDBenefits.whatExpensesAreYouClaimingFor',
    defaultMessage: 'What expenses are you claiming for?',
  },
  accidentalDeathAndDismembermentBenefitsGroup: {
    id: 'fastCover.adAndDBenefits.accidentalDeathAndDismembermentBenefitsGroup',
    defaultMessage: 'Accidental Death and Dismemberment Benefits',
  },
  airFlightCommonCarrierAccident: {
    id: 'fastCover.adAndDBenefits.airFlightCommonCarrierAccident',
    defaultMessage: 'Air Flight/Common Carrier Accident',
  },
  airFlightCommonCarrierAccidentTooltip: {
    id: 'fastCover.adAndDBenefits.airFlightCommonCarrierAccidentTooltip',
    defaultMessage:
      'Death or dismemberment as a result of an accident sustained during the period of coverage while riding as a fare-paying passenger, or while entering or leaving a lawfully operated licensed common carrier. Coverage is also applicable to insured children under two years accompanied by a fare paying passenger.',
  },
  accident24Hour: {
    id: 'fastCover.adAndDBenefits.accident24Hour',
    defaultMessage: '24-Hour Accident',
  },
  accident24HourTooltip: {
    id: 'fastCover.adAndDBenefits.accident24HourTooltip',
    defaultMessage:
      'Death or dismemberment as a result of an accident sustained during the period of coverage in any other situation not specifically mentioned under Air Flight/Common Carrier above.',
  },
  expenseFor: {
    id: 'fastCover.adAndDBenefits.expenseFor',
    defaultMessage: 'Expense For',
  },
  selectInsuredForExpense: {
    id: 'fastCover.adAndDBenefits.selectInsuredForExpense',
    defaultMessage: 'Select the insured for this expense',
  },
  descriptionOfExpense: {
    id: 'fastCover.adAndDBenefits.descriptionOfExpense',
    defaultMessage: 'Description of expense',
  },
  dateOfExpenses: {
    id: 'fastCover.adAndDBenefits.dateOfExpenses',
    defaultMessage: 'Date of expense',
  },
  amountClaimed: {
    id: 'fastCover.adAndDBenefits.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  currency: {
    id: 'fastCover.adAndDBenefits.currency',
    defaultMessage: 'Currency',
  },
  providerName: {
    id: 'fastCover.adAndDBenefits.providerName',
    defaultMessage: 'Provider Name',
  },
  addItem: {
    id: 'fastCover.adAndDBenefits.addItem',
    defaultMessage: 'Add Expense',
  },
  isRequired: {
    id: 'fastCover.adAndDBenefits.isRequired',
    defaultMessage: '\'{defaultMessage}\' is required',
  },
  checkEventDate: {
    id: 'fastCover.adAndDBenefits.checkEventDate',
    defaultMessage: 'Please enter a valid date',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/Tugo.ADAndDBenefits/messages.js